import React from 'react';
import styles from './VariantTabControl.module.css';

function VariantTabControl({ selectedTab, onTabChange, className }) {
    const isDark = selectedTab === 'dark';
    return (
        <div className={`${styles.tabContainer}${className ? ` ${className}` : ''}`}>
            <div className={`${styles.tabThumb} ${isDark ? styles.tabThumbRight : ''}`} />
            <button
                className={`${styles.tab} ${!isDark ? styles.tabActive : ''}`}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); onTabChange('light'); }}>
                Light
            </button>
            <button
                className={`${styles.tab} ${isDark ? styles.tabActive : ''}`}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); onTabChange('dark'); }}>
                Dark
            </button>
        </div>
    );
}

export default VariantTabControl;
